import { Accessory, Bike } from 'src/app/models/product.model';
import { RentalPoint } from 'src/app/models/rental-point.model';
import { Invoice } from 'src/app/models/invoice.model';

export class DataForm {
  startRental?: RentalPoint;
  endRental?: RentalPoint;
  from?: Date;
  to?: Date;
  previousSameRental?: boolean;
  previousBikes?: Bike[];
  bikes?: Bike[];
  accessories?: Accessory[];
  discountCard?: any;
  durationInDays? : number;
  price?: number;
  discountedPrice?: number;
  onlineDiscountedPrice?: number;
  differentRentalPointsPrice?: number;
  renterName?: string;
  email?: string;
  dialCode?: any;
  phone?: number;
  address?: string;
  comment?: string;
  privacy?: boolean;
  marketing?: boolean;
  isReservation?: boolean;
  invoice?: Invoice;
}
